import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideCommonOverview: React.FC = () => {
  return (
    <GuidePageLayout title="共通機能" description="全画面で共通して使用する機能の操作ガイドです。">
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="common/search-condition">検索条件の使い方</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              検索条件の保存・呼び出し・管理方法を説明します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="common/feedback">不具合報告・フィードバックを送る</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              不具合報告やフィードバックの送信方法を説明します。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideCommonOverview;
